import { isWhereClauseOp, WhereClauseOp } from "./WhereClauseOp";

/**
 * Represents a group of where clauses combined with logical operators.
 *
 * @interface AnnotationWhereGroup
 * @property id - Unique identifier for this annotation.
 * @property clauses - Array of where clause operations. Each clause (except the first) has a precedingLogic property.
 * @property additionalNotes - Free-text notes accompanying the annotation.
 */
export interface AnnotationWhereGroup {
  id: string;
  clauses: WhereClauseOp[];
  additionalNotes?: string;
}

/**
 * Type guard for AnnotationWhereGroup.
 *
 * @param obj - Value to test
 * @returns True when obj is a valid AnnotationWhereGroup
 */
export const isAnnotationWhereGroup = (obj: unknown): obj is AnnotationWhereGroup => {
  // Check object
  if (typeof obj !== "object" || obj === null) return false;

  // Check basic props
  const chkObj = obj as AnnotationWhereGroup;
  if (typeof chkObj.id !== "string") return false;
  if (!Array.isArray(chkObj.clauses) || chkObj.clauses.some((c) => !isWhereClauseOp(c)))
    return false;

  // Check optional props
  if (chkObj.additionalNotes !== undefined && typeof chkObj.additionalNotes !== "string")
    return false;

  // Everything is good
  return true;
};
